import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import { Link as LinkAnchor } from 'react-scroll';

import './ButtonSquare.css';


const ButtonSquare = (props) => {
  const {
    link, children, active,
  } = props;
  let classes = 'button';
  if (active) {
    classes += ' active';
  }
  if (link === '#' || link === '') {
    return (
      <div className={classes}>
        {children}
      </div>
    );
  }
  if (link && link[0] === '#') {
    return (
      <LinkAnchor to={link.substring(1)} smooth="true">
        <div className={classes}>
          {children}
        </div>
      </LinkAnchor>
    );
  }
  return (
    <Link to={link}>
      <div className={classes}>
        {children}
      </div>
    </Link>
  );
};

ButtonSquare.defaultProps = {
  children: null,
  active: false,
};

ButtonSquare.propTypes = {
  link: PropTypes.string.isRequired,
  children: PropTypes.element,
  active: PropTypes.bool,
};

export default ButtonSquare;



// WEBPACK FOOTER //
// ./src/components/ButtonSquare/BasicButton/ButtonSquare.jsx